import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M11.9999 1.99805C8.34893 1.99805 5.39893 4.94905 5.39893 8.59905C5.39893 13.5 11.0499 22.001 11.9999 22.001C12.9499 22.001 18.6009 13.539 18.6009 8.59905C18.6009 4.94805 15.6499 1.99805 11.9999 1.99805V1.99805ZM11.9999 12.08C10.0799 12.08 8.51893 10.52 8.51893 8.59905C8.51893 6.67805 10.0789 5.11805 11.9999 5.11805C13.9209 5.11805 15.4809 6.67805 15.4809 8.59905C15.4809 10.52 13.9209 12.08 11.9999 12.08Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'PinFill');

export default Icon;
